import { makeListState, makePaginationState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  reportCategories: makeListState(),
  episodes: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch report categories
    case `${t.FETCH_REPORT_CATEGORIES}_PENDING`:
      return {
        ...state,
        reportCategories: {
          ...state.reportCategories,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_REPORT_CATEGORIES}_ERROR`:
      return {
        ...state,
        reportCategories: {
          ...state.reportCategories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_REPORT_CATEGORIES}_SUCCESS`:
      return {
        ...state,
        reportCategories: {
          ...state.reportCategories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };

    // fetch story episodes
    case `${t.FETCH_STORY_EPISODES}_PENDING`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_STORY_EPISODES}_SUCCESS`:
      return {
        ...state,
        episodes: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.episodes.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };

    case `${t.FETCH_STORY_EPISODES}_ERROR`:
      return {
        ...state,
        episodes: {
          ...state.episodes,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET_EPISODES:
      return {
        ...state,
        episodes: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/report/reducer.js